import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, Card, Typography, Box, Button } from '@mui/material';
import './MessageModal.scss';

const MessageModal = ({ open, onClose, type, title, message }) => {
  const handleClose = () => {
    onClose();
    if (type === 'success') {
      window.location.reload();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Card sx={{ padding: 2, minWidth: 300 }}>
        <Typography variant="h6" gutterBottom>
          {title || (type === 'success' ? 'Success' : 'Error')}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {message}
        </Typography>
        <Box textAlign="right" mt={2}>
          <Button
            variant="contained"
            color={type === 'success' ? 'primary' : 'error'}
            onClick={handleClose}
          >
            OK
          </Button>
        </Box>
      </Card>
    </Dialog>
  );
};

MessageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['success', 'error']),
  title: PropTypes.string,
  message: PropTypes.string.isRequired
};

export default MessageModal;
